import { render, staticRenderFns } from "./SystemEmailTemplate.vue?vue&type=template&id=754a106c"
import script from "./SystemEmailTemplate.vue?vue&type=script&lang=js"
export * from "./SystemEmailTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports